import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin, Youtube, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img 
                src="/logo.png" 
                alt="Pro Cinemax" 
                className="h-16 w-auto mb-4"
              />
              <p className="text-gray-400 text-sm leading-relaxed">
                Bangalore's premier home theatre specialists. Transforming spaces into immersive entertainment experiences.
              </p>
            </div>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-cyan-600 rounded-full flex items-center justify-center transition-colors duration-200">
                <Facebook className="w-4 h-4 text-white" />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-cyan-600 rounded-full flex items-center justify-center transition-colors duration-200">
                <Instagram className="w-4 h-4 text-white" />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-cyan-600 rounded-full flex items-center justify-center transition-colors duration-200">
                <Twitter className="w-4 h-4 text-white" />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-cyan-600 rounded-full flex items-center justify-center transition-colors duration-200">
                <Linkedin className="w-4 h-4 text-white" />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-cyan-600 rounded-full flex items-center justify-center transition-colors duration-200">
                <Youtube className="w-4 h-4 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:pl-12">
            <h3 className="text-white font-semibold text-base mb-5 pb-2 border-b border-gray-800">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-cyan-500 transition-colors text-sm">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-cyan-500 transition-colors text-sm">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('packages')} className="text-gray-400 hover:text-cyan-500 transition-colors text-sm">
                  Packages
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('process')} className="text-gray-400 hover:text-cyan-500 transition-colors text-sm">
                  Process
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-gray-400 hover:text-cyan-500 transition-colors text-sm">
                  Designs
                </button>
              </li>
              <li>
                <a href="/blog" className="text-gray-400 hover:text-cyan-500 transition-colors text-sm">
                  Blog
                </a>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-cyan-500 transition-colors text-sm">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-base mb-5 pb-2 border-b border-gray-800">Our Services</h3>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm hover:text-cyan-500 transition-colors cursor-pointer">Dolby Atmos Theatre</li>
              <li className="text-gray-400 text-sm hover:text-cyan-500 transition-colors cursor-pointer">4K/8K Projection</li>
              <li className="text-gray-400 text-sm hover:text-cyan-500 transition-colors cursor-pointer">Acoustic Design</li>
              <li className="text-gray-400 text-sm hover:text-cyan-500 transition-colors cursor-pointer">Luxury Seating</li>
              <li className="text-gray-400 text-sm hover:text-cyan-500 transition-colors cursor-pointer">Theatre Room Design</li>
              <li className="text-gray-400 text-sm hover:text-cyan-500 transition-colors cursor-pointer">Calibration Services</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-base mb-5 pb-2 border-b border-gray-800 ml-11">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 bg-cyan-800/30 rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone className="w-4 h-4 text-cyan-500" />
                </div>
                <div>
                  <p className="text-white text-sm font-medium">+91 72042 47443</p>
                  <p className="text-gray-500 text-xs">Mon-Sat, 9AM-7PM</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 bg-cyan-800/30 rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail className="w-4 h-4 text-cyan-500" />
                </div>
                <div>
                  <p className="text-white text-sm font-medium">contact@procinemax.com</p>
                  <p className="text-gray-500 text-xs">24/7 Support</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 bg-cyan-800/30 rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-4 h-4 text-cyan-500" />
                </div>
                <div>
                  <p className="text-white text-sm font-medium">Hennur, Bengaluru</p>
                  <p className="text-gray-500 text-xs">Karnataka 560077</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6 mt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Pro Cinemax. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-500 hover:text-cyan-500 text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-cyan-500 text-sm transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
